// Todo el contenido del portafolio vive aquí.
// Para actualizar el sitio basta con editar este archivo y redesplegar.
// Los textos marcados con "TODO" son datos por confirmar.

export const profile = {
    name: 'Jairo de León',
    role: 'Analista Desarrollador Senior · Full-Stack & DevOps',
    tagline:
        'Construyo aplicaciones web de punta a punta con Spring Boot, Angular, Django y React, ' +
        'y las pongo en producción con Docker en mi propia infraestructura.',
    location: 'Ciudad de Guatemala, Guatemala',
    photo: '', // TODO: ruta de la foto en public/, p. ej. '/foto.jpg' (si queda vacío se muestra la inicial)
    github: 'https://github.com/jairodll',
    linkedin: 'https://www.linkedin.com/in/jsdldl/',
    cv: '', // TODO: URL del CV en PDF (se oculta si queda vacío)
};

export const about = {
    paragraphs: [
        'Soy Analista Desarrollador e Ingeniero en Sistemas guatemalteco, con experiencia en el sector ' +
        'público (SAT, sistemas aduaneros) y actualmente en banca. Trabajo con enfoque full-stack: mi base principal es ' +
        'Java con Spring Boot en el backend y Angular en el frontend, donde aplico arquitectura en capas, ' +
        'principios SOLID y código limpio.',
        'Me adapto rápido a nuevos ecosistemas: he llevado esos mismos principios a proyectos con Django ' +
        'REST Framework y React + TypeScript. Además administro mi propio servidor (VPS) con Docker, ' +
        'Dokploy y Traefik, donde despliego aplicaciones con HTTPS, automatizaciones con n8n e IA, ' +
        'y medidas de seguridad como fail2ban.',
        'Me interesa construir soluciones que resuelvan problemas reales de negocio, desde la idea ' +
        'hasta que están en línea y funcionando.',
    ],
    facts: [
        { label: 'Ubicación', value: 'Guatemala' },
        { label: 'Especialidad', value: 'Full-Stack · DevOps' },
        { label: 'Idiomas', value: 'Español · Inglés (en progreso)' },
        { label: 'Modalidad', value: 'Híbrido o remoto' },
    ],
};

export const education = [
    {
        title: 'Ingeniería en Sistemas',
        place: 'Universidad Mariano Gálvez',
        period: '2020 – 2024',
        description: 'Formación en programación, bases de datos, redes y análisis y diseño de sistemas.',
    },
    {
        title: 'AWS Certified Solutions Architect – Associate (SAA-C03)',
        place: 'AWS Training & Certification',
        period: 'En preparación',
        description: 'Curso oficial de preparación completado; en camino a la certificación.',
    },
    {
        title: 'Formación continua',
        place: 'Cursos y certificaciones en línea',
        period: 'Actualidad',
        description:
            'Autoaprendizaje práctico en DevOps (Docker, Linux, despliegues), automatización con n8n ' +
            'e integración de modelos de IA.',
    },
];

export const experience = [
    {
        role: 'Analista Desarrollador Senior',
        company: 'Banco CUSCATLAN Guatemala',
        period: 'abr. 2026 – Actualidad',
        highlights: [
            'Análisis y desarrollo de sistemas para el sector bancario.',
        ],
    },
    {
        role: 'Analista Desarrollador',
        company: 'Superintendencia de Administración Tributaria (SAT)',
        period: 'abr. 2023 – ene. 2026',
        highlights: [
            'Departamento de Sistemas Aduaneros, proyecto Modernización Integral Aduanera (MIAD).',
            'Trabajo en remoto.',
        ],
    },
    {
        role: 'Asesor de atención al cliente',
        company: 'Aspradco, S.A.',
        period: 'abr. 2021 – feb. 2023',
        highlights: [
            'Asesoría profesional de aduanas y computación, en remoto.',
        ],
    },
    {
        role: 'DevOps & Automatización',
        company: 'Proyectos propios',
        period: '2026 – Actualidad',
        highlights: [
            'Administración de un VPS Linux con Docker, Dokploy y Traefik (HTTPS automático con Let\'s Encrypt).',
            'Flujos de automatización con n8n integrados con IA (Groq) y Notion.',
            'Endurecimiento del servidor: fail2ban, cierre de puertos y monitoreo de ataques.',
        ],
    },
];

export const skills = [
    { group: 'Backend', items: ['Java', 'Spring Boot', 'Python', 'Django', 'Django REST Framework', 'APIs REST', 'JWT'] },
    { group: 'Frontend', items: ['Angular', 'TypeScript', 'React', 'Material UI', 'HTML', 'CSS'] },
    { group: 'DevOps', items: ['Docker', 'Docker Compose', 'Dokploy', 'Traefik', 'Nginx', 'Linux', 'Git / GitHub'] },
    { group: 'Datos & Automatización', items: ['PostgreSQL', 'SQLite', 'n8n', 'Groq API', 'Notion API'] },
];

export const projects = [
    {
        title: 'Este portafolio',
        description:
            'Sitio de una sola página con formulario de contacto, área privada con login JWT para ' +
            'revisar solicitudes y mapa de ubicación.',
        tags: ['Django', 'React', 'Docker', 'Dokploy'],
    },
    {
        title: 'Gestor de tareas',
        description:
            'Prueba técnica full-stack: CRUD de tareas con autenticación JWT, filtros, paginación ' +
            'y gráfica semanal de tareas completadas.',
        tags: ['Django REST', 'React', 'Chart.js', 'JWT'],
    },
    {
        title: 'Reporte diario de ataques',
        description:
            'Automatización que toma los bloqueos de fail2ban del servidor, los resume con IA y ' +
            'publica un reporte diario en Notion.',
        tags: ['n8n', 'Groq', 'Notion', 'fail2ban'],
    },
    {
        title: 'Agente DevOps diario',
        description:
            'Flujo en n8n que envía por correo un concepto de DevOps cada día, generado con IA, ' +
            'para aprendizaje continuo.',
        tags: ['n8n', 'IA', 'Email'],
    },
];

// Ubicación de la oficina (se muestra en el mapa)
export const office = {
    name: 'Oficina',
    address: 'Zona 10, Ciudad de Guatemala',
    lat: 14.6010,
    lng: -90.5105,
};
